import Link from "next/link";
import { SecondaryButton } from "ui/components";
import { UserIcon } from "ui/iconsN";
import type { CustomerData } from "../../getCustomerData";
import { MenuLink } from "./MenuLink";

type Props = {
  customerData: CustomerData;
};
export const AccountMenu = ({ customerData }: Props) => {
  if (!customerData.isConnected) {
    return (
      <div className="flex items-center gap-3 max-[1240px]:hidden">
        <MenuLink href="/amis/se-connecter/">Se connecter</MenuLink>
        <Link href="/amis/abonnement/" className="not-les-amis-theme">
          <SecondaryButton direction="up" size="sm" className="px-4!">
            Essayer gratuitement
          </SecondaryButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 max-[1240px]:hidden">
      <div className="relative group">
        <div className="absolute -right-2 -top-2 flex flex-col items-end gap-0.5 bg-bg-2/60 pt-10 pr-2 pb-3 pl-6 rounded-lg backdrop-blur-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none group-hover:pointer-events-auto">
          <MenuLink href="/amis/mon-compte/">Informations personnelles</MenuLink>
          <MenuLink href="/amis/mon-compte/inscriptions/">Mes inscriptions</MenuLink>
          <MenuLink href="/amis/mon-compte/historique/">Historique</MenuLink>
          <div className="absolute inset-0 rounded-lg border border-tx-1/25 mix-blend-soft-light pointer-events-none" />
        </div>
        <div className="text-sm/4 font-medium flex items-center px-1.5 py-1 gap-1.5 relative z-1 cursor-pointer">
          <UserIcon className="size-[14px]" />
          <Link href="/amis/mon-compte/" className="whitespace-nowrap line-clamp-1">
            {customerData.firstname} {customerData.lastname}
          </Link>
        </div>
      </div>
      {customerData.subscriptionStatus === null && !customerData.hasFreeSubscription && (
        <Link href="/amis/abonnement/" className="not-les-amis-theme">
          <SecondaryButton direction="up" size="sm" className="px-4!">
            {customerData.hasPastSubscription ? "Se réabonner" : "Essayer gratuitement"}
          </SecondaryButton>
        </Link>
      )}
    </div>
  );
};
